const NPI_ADDRESS_INFORMATION_KEY = "npiAddressInformation";
const SKIP_CERTIFICATION_UPLOAD = "skipCertificationUpload";
const ONBOARDING_SUCCESS_KEY = "onboardingSuccess";
const ONBOARDING_SHIPPING_MODAL_SHOWN = "onboardingShippingModalShown";
const ACCOUNT_SETUP_MENU_TIME = "accountSetupMenuTime";
const CLASSIC_MIGRATION_MODAL_SHOWN = "classicMigrationModalShown";
const CATALOG_ASSIST_INFO_PANEL_DISMISSED = "catalogAssistInfoPanelDismissed";
const SEGMENTATION_QUESTIONS_COMPLETED = "segmentationQuestionsCompleted";
const FRIEND_INVITES_CALLOUT_DISMISSED = "friendInvitesCalloutDismissed";
const ASSIST_JUNE_GTM_BANNER_DISMISSED = "assist_june_gtm_banner_dismissed";
const JOURNEYS_IN_OFFICE_ACTIVATION_MODAL_SEEN = "journeysInOfficeActivationModalSeen";

export {
  NPI_ADDRESS_INFORMATION_KEY,
  SKIP_CERTIFICATION_UPLOAD,
  ONBOARDING_SUCCESS_KEY,
  ONBOARDING_SHIPPING_MODAL_SHOWN,
  ACCOUNT_SETUP_MENU_TIME,
  CLASSIC_MIGRATION_MODAL_SHOWN,
  CATALOG_ASSIST_INFO_PANEL_DISMISSED,
  SEGMENTATION_QUESTIONS_COMPLETED,
  FRIEND_INVITES_CALLOUT_DISMISSED,
  ASSIST_JUNE_GTM_BANNER_DISMISSED,
  JOURNEYS_IN_OFFICE_ACTIVATION_MODAL_SEEN,
};
